import * as React from 'react';
import { default as MainCollapsible, CollapsibleProps } from 'react-collapsible';
import styled from 'styled-components';

const CollapsibleWrap = styled.div`
  .md__collapsible__trigger {
    display: block;
    position: relative;
  }
  .md__collapsible__trigger:after {
    color: var(--md-purple-color);
    content: '+';
    display: block;
    font-family: 'FontAwesomeSolid';
    font-size: 52px;
    font-weight: bold;
    margin-right: 10px;
    position: absolute;
    right: 10px;
    text-align: center;
    top: 15px;
    transition: transform 300ms;
  }
  .md__collapsible__trigger.is-open {
    border: 0;
    color: #343434;
  }
  .md__collapsible__trigger.is-open:after {
    color: var(--md-purple-color);
    content: '-';
    margin-right: 13px;
    transform: rotateZ(180deg);
  }

  @media only screen and (max-width: 415px) {
    .md__collapsible__trigger:after {
      font-size: 41px;
      transform: translateY(-50%);
      top: 50%;
    }
    .md__collapsible__trigger.is-open:after {
      transform: translateY(-50%) rotateZ(180deg);
    }
  }
`;

export const Collapsible = ({ trigger = '', children, ...props }: CollapsibleProps) => (
  <CollapsibleWrap>
    <MainCollapsible
      trigger={trigger}
      classParentString="md__collapsible"
      contentInnerClassName="p-0 border-b-2 border-md-bg-gray"
      {...props}
    >
      {children}
    </MainCollapsible>
  </CollapsibleWrap>
);
